<template>
    <v-footer
      dark
      height="auto"
    >
      <v-card
        flat
        tile
        class="lighten-1 white--text text-xs-center"
      >
        <v-card-text>
          <v-btn
            v-for="(icon, i) in icons"
            :key="icon"
            :href="urls[i]"
            class="mx-3 white--text"
            icon
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-card-text class="white--text">
          &copy;{{year}} — <strong><a href="http://sixsigmatv.net">SixSigmaTV.net</a></strong>
        </v-card-text>
      </v-card>
    </v-footer>
</template>

<script>
export default {
  name: 'foot',
  data: () => ({
    year: new Date().getFullYear(),
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-linkedin',
      'fab fa-youtube',
      'fab fa-instagram'
    ],
    urls: [
      'https://www.facebook.com/SixSigmaTV.net/',
      'https://twitter.com/6SigmaTV',
      'https://www.linkedin.com/company/sixsigmatv.net',
      'https://www.instagram.com/sixsigmatv/',
      'https://www.youtube.com/user/SixSigmaTV'
    ]
  })
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}
.v-card {
  width: 100%;
}
</style>
